<template>
  <div v-if="isReady || false" class="shell">
    <h1>Client Guard Alert</h1>
    <h3>Verify recipients of client data:</h3>
    <ul class="recipient-list">
      <li v-for="item in recipients" :key="item.email" class="recipient-list-item">
        <ms-checkbox v-model="item.value" :label="item.emailAddress" />
        <div v-if="item.status === 'approved'" class="recipient-list-item-status recipient-list-item-status-ok">Approved</div>
        <div v-else-if="item.status === 'unknown'" class="recipient-list-item-status recipient-list-item-status-warning">Unknown recipient</div>
      </li>
    </ul>
    <div class="submit">
      <ms-button color="primary" :disabled="!canSend" @click.stop.prevent="ok">Send</ms-button>
      <ms-button @click.stop.prevent="cancel">Don't send</ms-button>
    </div>
  </div>
  <div v-else><ms-loading :size="'large'" :justify="true" /></div>
</template>

<script>
import logger from '@/utils/logger';

import Checkbox from '@/components/ms/Checkbox';
import Button from '@/components/ms/Button';
import Loading from '@/components/ms/Loading';

import { mapState } from 'vuex';
export default {
  components: { 'ms-checkbox': Checkbox, 'ms-button': Button, 'ms-loading': Loading },
  data() {
    return {
      subject: '',
      recipients: []
    };
  },
  computed: {
    ...mapState({
      isReady: s => s.isReady,
      to: s => s.to,
      cc: s => s.cc,
      bcc: s => s.bcc,

      all: s => [...s.to, ...s.cc, ...s.bcc]
    }),
    canSend() {
      return !!this.recipients.find(item => !!item.value);
    }
  },
  watch: {
    all() {
      this.recipients = this.all
        .map(item => ({
          emailAddress: item.emailAddress,
          displayName: item.displayName,
          value: item.status === 'approved',
          status: item.status ?? 'unknown'
        }))
        .filter((item, index, array) => {
          return array.findIndex(_ => _.emailAddress === item.emailAddress) === index;
        });
    }
  },
  methods: {
    ok() {
      try {
        Office.context.ui.messageParent(
          JSON.stringify({
            action: 'ok',
            data: {
              to: this.to.filter(item => this.recipients.find(rcp => rcp.emailAddress === item.emailAddress && rcp.value)),
              cc: this.cc.filter(item => this.recipients.find(rcp => rcp.emailAddress === item.emailAddress && rcp.value)),
              bcc: this.bcc.filter(item => this.recipients.find(rcp => rcp.emailAddress === item.emailAddress && rcp.value))
            }
          })
        );
      } catch (e) {
        logger.error(e);
      }
    },
    cancel() {
      try {
        Office.context.ui.messageParent(JSON.stringify({ action: 'cancel' }));
      } catch (e) {
        logger.error(e);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h1 {
  text-align: center;
  margin: 20px 0 0;
  color: var(--theme-warning);
}
h3 {
  text-align: center;
  margin: 40px 0;
}

a {
  color: #42b983;
}

.shell {
  padding: 0.5rem 1rem;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: max-content max-content minmax(0, 1fr) max-content;
  width: 100%;
  height: 100%;
  width: 600px;
  margin: 0 auto;
}

.recipient-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  overflow-y: auto;
}

.recipient-list-item {
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) max-content;
  grid-gap: 10px;
  align-items: center;
}

.recipient-list-item-status {
  font-weight: 700;
  font-size: 0.9;
}

.recipient-list-item-status-ok {
  color: var(--theme-success);
}
.recipient-list-item-status-warning {
  color: var(--theme-warning);
}

.submit {
  align-items: center;
  justify-content: flex-end;
  display: flex;
  > button:not(:last-child) {
    margin-right: 1rem;
  }
}
</style>
